/* eslint-disable */
export const environmentConfig = {
    InternalDashboardHost: "https://people.thefanclash.co.za/api",
    smsIntegrationService: "https://utils.vodacomfantasy.com",
};
